// frontend/src/services/invoice.service.js
import { apiService } from "./../../app.service";

export const invoiceApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllInvoices: builder.query({
      query: () => ({
        url: "/invoices/invoices",
        method: "GET",
      }),
      providesTags: ["Invoices"],
    }),

    getInvoiceById: builder.query({
      query: (invoiceId) => ({
        url: `/invoices/invoices/${invoiceId}`,
        method: "GET",
      }),
      providesTags: (result, error, invoiceId) => [
        { type: "Invoices", id: invoiceId },
      ],
    }),

    downloadInvoice: builder.mutation({
      query: (invoiceId) => ({
        url: `/invoices/invoices/${invoiceId}/download`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetAllInvoicesQuery,
  useGetInvoiceByIdQuery,
  useDownloadInvoiceMutation,
} = invoiceApi;